define('companiesDetailBodyTabsView',[
  'app',
  'module',
  'underscore',
  'rolesMixin',
  'settings',
  'tabsView'
], function (
  App,
  Module,
  _,
  RolesMixin,
  Settings,
  TabsView
) {
  'use strict';

  Module.exports = TabsView.extend({
    fetch: function () {
      if (!Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_CUSTOMERS_COMPANIES]) {
        return;
      }

      this.collection.push({
        name: 'info',
        title: _.i18n('companies.info.tabTitle', null, 'Info'),
        defaultSelected: true,
        role: RolesMixin.DASHBOARD_CUSTOMERS_COMPANIES
      });
      this.collection.push({
        name: 'subaccounts',
        title: _.i18n('companies.subaccounts.tabTitle', null, 'Sub-accounts'),
        role: RolesMixin.DASHBOARD_CUSTOMERS_COMPANIES
      });
      this.collection.push({
        name: 'orders',
        title: _.i18n('endUsersDetail.orders.tabTitle'),
        role: RolesMixin.DASHBOARD_CUSTOMERS_COMPANIES
      });
      this.collection.push({
        name: 'offers',
        title: _.i18n('endUsersDetail.offers.tabTitle'),
        role: RolesMixin.DASHBOARD_CUSTOMERS_COMPANIES
      });
    }
  });
});

